import shajs from 'sha.js'

export const hashObject = (obj: Record<string, unknown> | string): string => {
  return shajs('sha256')
    .update(JSON.stringify(obj))
    .digest('hex')
}
